import React from 'react';
import './UserNotices.scss';
import { getUserNotices } from '../../utils/userNotices';

const UserNoticesPanel = ({
  activePlan,
  onUpgrade,
  onManageBilling,
}) => {
  const notices = getUserNotices(activePlan);

  if (notices.length === 0) {
    return null;
  }

  const handleAction = (action) => {
    if (action === 'billing') {
      onManageBilling?.();
      return;
    }
    if (action === 'upgrade') {
      onUpgrade?.();
    }
  };

  return (
    <section className="user-notices-panel card">
      <div className="card-body">
        <div className="user-notices-panel-heading">
          <h4>Account notices</h4>
          <p>Important updates about your trial, billing, and plan access.</p>
        </div>
        <div className="user-notices-panel-list">
          {notices.map((notice) => (
            <div key={notice.id} className={`user-notice-item user-notice-item--${notice.tone}`}>
              <span className="user-notice-label">{notice.label}</span>
              <span className="user-notice-message">{notice.message}</span>
              {notice.ctaLabel && (
                <button
                  type="button"
                  className="user-notice-cta"
                  onClick={() => handleAction(notice.ctaAction)}
                >
                  {notice.ctaLabel}
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UserNoticesPanel;
